import prettier from 'prettier/standalone'
import parserHtml from 'prettier/parser-html'
import parserPostcss from 'prettier/parser-postcss'
import parserBabylon from 'prettier/parser-babylon'

const PRETTIER_OPTIONS = Object.freeze({
  parser: 'html',
  plugins: [parserHtml, parserPostcss, parserBabylon],
  printWidth: 120,
  tabWidth: 2,
  useTabs: false,
  singleQuote: false,
  bracketSpacing: true,
  htmlWhitespaceSensitivity: 'css',
})

function formatHtml(input) {
  if (typeof input !== 'string') return input
  const source = input.replace(/\r\n/g, '\n').trim()
  if (!source) return ''

  try {
    return prettier.format(source, PRETTIER_OPTIONS).replace(/\n+$/, '')
  } catch (e) {
    return input
  }
}

export default formatHtml
